import axios, { AxiosInstance, AxiosError } from 'axios'
import { getApiBaseUrl } from '../config/runtimeEnv'

const API_BASE_URL = getApiBaseUrl()

export { getApiBaseUrl }

class APIClient {
  private client: AxiosInstance

  constructor() {
    this.client = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    // Request interceptor to add auth token
    this.client.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token')
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    // Response interceptor for error handling
    this.client.interceptors.response.use(
      (response) => response,
      (error: AxiosError) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('token')
          // Reload Gmail portal with flag so landing page can show "session expired" instead of sending user away
          const base = window.location.origin + window.location.pathname
          window.location.href = `${base}?session_expired=1`
          return Promise.reject(error)
        }
        return Promise.reject(error)
      }
    )
  }

  getClient() {
    return this.client
  }
}

export const apiClient = new APIClient().getClient()
export default apiClient

